import type { OrganizationalRecordItemReferenceFragment } from "@/graphql/generated/operations";

export type OrganizationalRecordReference = Pick<OrganizationalRecordItemReferenceFragment, "id" | "kind" | "title"> & { entryId?: string | null };
export type OrganizationalRecordNavigate = (reference: OrganizationalRecordReference) => void;
export const linkInputs = (links: readonly OrganizationalRecordReference[]) => links.map(({ id, kind }) => ({ id, kind }));
